import type { SupabaseClient } from "@supabase/supabase-js";

/** Sign-in never creates an account; membership remains the access decision. */
export async function requestEmailLink(auth: Pick<SupabaseClient["auth"], "signInWithOtp">, email: string, origin: string): Promise<void> {
  const { error } = await auth.signInWithOtp({
    email: email.trim(),
    options: { shouldCreateUser: false, emailRedirectTo: `${origin}/` },
  });
  if (error) throw error;
}
